import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconArchive = createIcon({
  displayName: 'IconArchive',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M13 5V3H22V9H2V3H11V5H4V7H20V5H13ZM18 20H6V11H4V22H20V11H18V20ZM15 12H9V14H15V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
